module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10812/images/homepage/company-logos-es/Nubox-1-1.webp"